// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var PasswordDraft = function (x) {
    return x;
};
var tsBridgePasswordDraft = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("PasswordDraft")("__brandPasswordDraft"));
    }
};
var writePasswordDraft = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showPasswordDraft = Data_Show.showString;
var readPasswordDraft = Simple_JSON.readString;
var ordPasswordDraft = Data_Ord.ordString;
var newtypePasswordDraft = {
    Coercible0: function () {
        return undefined;
    }
};
var makePasswordDraft = PasswordDraft;
var eqPasswordDraft = Data_Eq.eqString;
export {
    PasswordDraft,
    makePasswordDraft,
    unwrap,
    newtypePasswordDraft,
    eqPasswordDraft,
    ordPasswordDraft,
    showPasswordDraft,
    readPasswordDraft,
    writePasswordDraft,
    tsBridgePasswordDraft
};
//# sourceMappingURL=index.js.map
